export default __webpack_public_path__ + "static/media/WorkingArt.5e350c02.svg";